module.exports = __webpack_public_path__ + "img/【诊改行动】携手同行，聚势共赢！上电智联助力盐发机械开启轻量数字化改造项目.2afc1b32.jpg";